import './side-nav-divider.scss';

export const SideNavDivider = () => <div className="sidenav-divider" />;
